import styled from "styled-components"
import { colors } from '../../../helpers/consts'
import secondary_bg from '../../../images/Secondary_BG.svg'

export const Section = styled.section`
  width: 100%;
  padding: 2rem 0;
  background-color: ${colors.lightBlue};
  background-image: url(${secondary_bg});
  background-size: 100% auto;
  background-position: bottom;
  background-repeat: no-repeat;

  @media (min-width: 48em) {
    padding: 4rem 0;
  }

  @media (min-width: 62em) {
    padding: 8rem 0 6rem;
  }

  @media (min-width: 112em) {
    padding: 11rem 0 9rem;
  }
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  width: 100%;

  @media (min-width: 62em) {
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
  }
`

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 1rem;

  img {
    padding: 0 6rem;
    margin-bottom: 1.2rem;
    border-radius: 1.5rem;

    @media (min-width: 48em) {
      max-width: 45rem;
      padding: 0;
      margin-bottom: 2rem;
    }

    @media (min-width: 62em) {
      max-width: 60rem;
      margin-bottom: 3.8rem;
    }
  }

  a {
    margin-bottom: 2rem;

    @media (min-width: 62em) {
      margin-top: 5rem;
      margin-bottom: 0;
    }
  }

  @media (min-width: 62em) {
    align-items: flex-start;

    :last-of-type {
      margin-left: 8rem;
    }
  }
`
